/**
 * The document's title while the calling page is mounted, restored to what
 * it was when the page leaves, so a page that sets none does not wear the
 * last one.
 */import{useEffect}from"react";export default function useDocumentTitle(title){useEffect(()=>{const previousTitle=document.title;document.title=title;return()=>{document.title=previousTitle;};},[title]);}